import { Directive, HostListener } from '@angular/core'

import { UtilityService } from '@core/services/utility.service'

@Directive({
  selector: '[linMacAddress]',
  standalone: false,
})
export class MacAddressDirective {
  constructor(private readonly utilityService: UtilityService) {}

  @HostListener('input', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement

    input.value = !input.value ? '' : this.utilityService.toMacAddress(input.value)
  }
}
